import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateTourPayload } from '@app-store/slices/tours/create'

interface TaskAction extends Action {
    payload: ICreateTourPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.tours.create

function* createTourSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.post(`/event/tour`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(payload.sagaCB?.onSuccess(response.result.data))
            notification.success({
                message: 'Tour created successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* createTourSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createTourSagaTask)
}

export default createTourSaga
